module.exports = __webpack_public_path__ + "img/guide.6c2fb622.jpg";